import { Box, Image, Text, Flex } from "@chakra-ui/react";
import React from "react";
import btcSrc from "../assets/btc.png";

import { motion } from "framer-motion";

const Home = () => {
  return (
    <Box bgColor={"blackAlpha.900"} w={"full"} h={"85vh"}>
      <Flex direction="row" justify={'center'}>
        {/* <Image
          w={"full"}
          h={"70vh"}
          objectFit={"contain"}
          src={btcSrc}
          filter={"grayscale()"}
        /> */}

        <motion.div
          style={{
            height: "70vh",
            marginRight: "1rem",
          }}
          animate={{
            scale: [1, 0.1, 0, 1],
            // rotate: [0, 360, 0, 0],

          }}
          transition={{
            duration: 9, // Adjust the duration as per your preference
            repeat: Infinity,
            delay: 1,
          }}
        >
         <Image
  w={"full"}
  h={"65vh"}
  objectFit={"contain"}
  src={btcSrc}
  filter={"contrast(200%)"}
  mx="auto" // horizontally center the image
  my="auto" // vertically center the image
/>

        </motion.div>

        {/* <Image
          w={"full"}
          h={"70vh"}
          objectFit={"contain"}
          src={btcSrc}
          filter={"grayscale(2)"}
        /> */}
      </Flex>

      <Text
        fontSize={"7xl"}
        textAlign={"center"}
        fontWeight={"thin bold"}
        fontFamily={"cursive"}
        color={"blue"}
        mt={"-20"}
        shadow={''}
        // bgColor={"gray"}
      >
        AS3
      </Text>
    </Box>
  );
};

export default Home;
